import { configureStore } from '@reduxjs/toolkit';
import tokenReducer from '../features/token/token';
import inputReducer, { populateInputs } from '../features/inputs/inputs';
import sessionReducer from '../features/session/sessionId';
import betaAuthReducer from '../features/betaAuth/betaAuth';
import { loadState, saveState } from '../localStorage';

const preloadedStateToken = loadState('token');
const preloadedStateInputs = loadState('inputs');
const preloadedStateSession = loadState('sessionId');
const preloadedBetaAuth = loadState('betaAuth');

const preloadedState = {
  token: preloadedStateToken,
  inputs: preloadedStateInputs,
  sessionId: preloadedStateSession,
  betaAuth: preloadedBetaAuth,
};

const store = configureStore({
  reducer: {
    token: tokenReducer,
    inputs: inputReducer,
    sessionId: sessionReducer,
    betaAuth: betaAuthReducer,
  },
  preloadedState: preloadedState ? preloadedState : undefined,
});

// Revalidate any inputs loaded from sessionStorage against current app options
if (preloadedStateInputs?.value) {
  store.dispatch(populateInputs(preloadedStateInputs.value));
}

// Centralized persistence — replaces saveState() calls inside reducers
store.subscribe(() => {
  const state = store.getState();
  saveState('inputs', state.inputs);
});

export default store;
